<template>
    <div class="not-found-container">
        <vue-headful :title="'403 - WTS'" />

        <div class="text-center">
            <h1 class="not-found-status">403</h1>
            <h2 class="not-found-message">Permission Denied</h2>

            <template v-if="permissions.length > 0">
                <div class="alert alert-warning mt-4">
                    <h5>You need one of the following permissions to access this resource:</h5>
                    <ol class="text-left font-weight-bold">
                        <li v-for="perm in permissions">
                            {{ perm.name }}
                        </li>
                    </ol>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                params: this.$route.query,
                permissions: [],
            }
        },

        computed: {

            slugs(){
                //Check the params
                if(this.params.permissions && this.params.permissions.length > 0)
                {
                    return this.params.permissions;
                }

                //Send it
                return null;
            }
        },

        methods: {
            getPermissions(){
                //Send it
                this.$http.get('/admin/permissions', {slugs: this.slugs})
                    .then(response => {
                        //Set the user
                        this.permissions = response.data;
                    })
                    .catch(error => {

                    })
                    .then(() => {
                        //Reset
                        this.loading = false;
                    });
            }
        },

        mounted(){
            //Check for permissions
            if(this.slugs)
            {
                this.getPermissions();
            }
        }
    }
</script>

<style lang="css" scoped>
    .not-found-container {
        width: 100%;
        min-height: 50vh;
        background: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .not-found-status {
        font-size: 10rem;
        font-weight: 400;
        margin: 0;
        line-height: 1;
    }

    .not-found-message {
        font-weight: 300;
        font-size: 3.25rem;
        margin: 0;
        line-height: 1;
    }
</style>

